import 'zone.js'
import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import { AppModule } from './app/app.module'
import { environment } from './environments/environment'

if (environment.shopify.embedded) {
  const script = document.createElement('script')
  script.src = 'https://cdn.shopify.com/shopifycloud/app-bridge.js'
  script.async = false
  script.dataset.disabledFeatures = 'auto-redirect'  // ← disable CDN auto-redirect
  document.head.prepend(script)

  const meta = document.createElement('meta')
  meta.name = 'shopify-api-key'
  meta.content = String(environment.shopify.clientId || '')
  document.head.prepend(meta)
}

if (environment.production) {
  enableProdMode()
}

console.log('APP', environment.shopify.clientId, 'IS EMBEDDED', environment.shopify.embedded)

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => {
    console.error(err)
  })

const script: HTMLScriptElement = document.createElement('script')
script.setAttribute('id', 'widget-script')
script.async = true
script.setAttribute('src', `${environment.widgetPreviewURL}?timestamp=${+new Date()}`)
script.setAttribute('data-source', 'dashboard')
document.body.appendChild(script)
